const items = [
    { key: 'A', title: 'Algorithm', hasDetailPage: true, date: '2026-03-27' },
    { key: 'B', title: '', hasDetailPage: false },
    { key: 'C', title: 'Coffee', hasDetailPage: true, date: '2026-03-26' },
    { key: 'D', title: 'Designer', hasDetailPage: true, date: '2026-03-31' },
    { key: 'E', title: '', hasDetailPage: false },
    { key: 'F', title: 'Fortune', hasDetailPage: true, date: '2026-05-24' },
    { key: 'G', title: '', hasDetailPage: false },
    { key: 'H', title: 'Homebody', hasDetailPage: true, date: '2026-04-08' },
    { key: 'I', title: '', hasDetailPage: false },
    { key: 'J', title: 'mbti-J', hasDetailPage: true, date: '2026-04-05' },
    { key: 'K', title: 'Kidult', hasDetailPage: true, date: '2026-03-29' },
    { key: 'L', title: '', hasDetailPage: false },
    { key: 'M', title: 'Memory', hasDetailPage: true, date: '2026-06-03' },
    { key: 'N', title: '', hasDetailPage: false },
    { key: 'O', title: '', hasDetailPage: false },
    { key: 'P', title: 'Postgraduate', hasDetailPage: true, date: '2026-03-26' },
    { key: 'Q', title: '', hasDetailPage: false },
    { key: 'R', title: '', hasDetailPage: false },
    { key: 'S', title: 'Stubborn', hasDetailPage: true, date: '2026-04-19' },
    { key: 'T', title: '', hasDetailPage: false },
    { key: 'U', title: '', hasDetailPage: false },
    { key: 'V', title: 'Versatile', hasDetailPage: true, date: '2026-03-29' },
    { key: 'W', title: '', hasDetailPage: false },
    { key: 'X', title: '', hasDetailPage: false },
    { key: 'Y', title: '', hasDetailPage: false },
    { key: 'Z', title: 'Zzz', hasDetailPage: true, date: '2026-05-10' }
];

export default items;
